import { StyleSheet } from 'react-native';
import { themes } from '../../../theme/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: themes.light.white[1],
  },
  scrollContainer: {
    gap: 16,
    padding: 16,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 12,
  },
  backButton: {
    flex: 1,
    maxWidth: '33%',
  },
  purchaseButton: {
    flex: 1,
    maxWidth: '67%',
  },
});
